export default __webpack_public_path__ + "2d9e72f84c76b3cc069aaeeecde0ca10.svg";